module.exports = __webpack_public_path__ + "img/Sertifikat-Tukang.62929252.png";